import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material'
import { Provider } from 'react-redux'
import './App.css'
import Snackbar from './components/Snackbar'
import MainNavigation from './navigation/MainNavigation'
import { store } from './services/redux/store'
import { lightTheme } from './theme/themeValues'

function App() {
    return (
        <>
            {/* Changes CSS injection order. Docs: https://mui.com/guides/interoperability/#css-injection-order */}
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={lightTheme}>
                    <CssBaseline />
                    <Provider store={store}>
                        <Snackbar />
                        <MainNavigation />
                    </Provider>
                </ThemeProvider>
            </StyledEngineProvider>
        </>
    )
}

export default App
